import { formatWelloPoint } from '@/utils/formatWelloPoint';

import type { BenefitMenuCpc } from './resolveBenefitMenuGroups';

export const resolveCpcBadgeLabel = ({
  rewardPoint,
  isParticipated,
  isDaily,
}: BenefitMenuCpc) => {
  if (isParticipated) {
    return isDaily ? '오늘 완료' : '미션 완료';
  }

  const point = formatWelloPoint(rewardPoint, { signed: true });

  return isDaily ? `${point} · 매일` : point;
};
